import React from 'react';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import SkeletonView from '@@viewCommonComponents/groupProtection/SkeletonView.jsx';

const SouscriptionRecapGroupProtection = ({ getMiddleText }) => (
  <SkeletonView title={'Récapitulatif'} getMiddleText={getMiddleText} />
);

export default withMiddleFeatures(SouscriptionRecapGroupProtection);
